import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Wizard from './Wizard';
// import WizardDiagnostics from './WizardDiagnostics'; // Diagnostics disabled
import CustomAgentBuilder from './CustomAgentBuilder';
import './WizardView.css';

export default function WizardView() {
  return (
    <div className="wizard-view" style={{ background: '#F7F9FC', minHeight: 'calc(100vh - 10px)', width: '100%', borderRadius: '10px 0px 0px 0px', marginTop: '10px', overflow: 'hidden' }}>
      <Routes>
        <Route index element={<Navigate to="custom-agents" replace />} />
        <Route path="custom-agents" element={<Wizard />} />
        <Route path="custom-agents/new" element={<CustomAgentBuilder />} />
        <Route path="custom-agents/:id" element={<CustomAgentBuilder />} />
        {/* Diagnostics route disabled */}
        {/* <Route path="diagnostics" element={<WizardDiagnostics />} /> */}
      </Routes>
    </div>
  );
} 